function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Client from '@searchkit/instantsearch-client';
import c from 'classnames';
import { Configure, InstantSearch } from 'react-instantsearch';
import Searchkit from 'searchkit';
import AnalyticsHandler from '../Analytics';
import { DEFAULT_HITS_PER_PAGE, DEFAULT_REQUEST_OPTIONS } from '../../config/constants';

// Omit `searchClient` when extending the InstantSearchProps.
// We do that because we calculate the searchClient in this component
// and pass it to the <InstantSearch> wrapper anyways.
const SearchkitWrapper = _ref => {
  let {
    connection,
    indexName,
    searchSettings,
    requestOptions = DEFAULT_REQUEST_OPTIONS,
    routing = false,
    analytics = false,
    className,
    onlyFetchWithQuery,
    onlyFetchWithQueryFunction = requests => requests.some(_ref2 => {
      let {
        params: {
          query
        } = {}
      } = _ref2;
      return query !== undefined && query !== '';
    }),
    children,
    hitsPerPage = DEFAULT_HITS_PER_PAGE,
    ...restProps
  } = _ref;
  const classNames = c('Searchkit', className);
  const searchClient = React.useMemo(() => {
    const sk = new Searchkit({
      connection,
      search_settings: searchSettings
    });
    const client = Client(sk, requestOptions);
    if (!onlyFetchWithQuery) {
      // Skip the overriding of the search function below.
      return client;
    }
    return {
      ...client,
      search: requests => {
        // Only search if we actually have a query value.
        // This prevents an inital empty call from being executed, leading to a worse page speed.
        // NB: This functionality may break things, like facet filter search.
        if (onlyFetchWithQueryFunction(requests)) {
          return client.search(requests);
        }
        return Promise.resolve({
          results: [{
            hits: []
          }]
        });
      }
    };
  }, [connection, searchSettings, requestOptions, onlyFetchWithQuery, onlyFetchWithQueryFunction]);
  const searchParameters = {};
  if (hitsPerPage > 0) {
    searchParameters.hitsPerPage = hitsPerPage;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement(InstantSearch, _extends({}, restProps, {
    indexName: indexName,
    searchClient: searchClient,
    routing: routing
  }), analytics && /*#__PURE__*/React.createElement(AnalyticsHandler, {
    indexName: indexName
  }), /*#__PURE__*/React.createElement(Configure, searchParameters), children));
};
export default SearchkitWrapper;